import { css } from 'styled-components';
export const BKJTextInputBaseCSS = css `
  caret-color: auto !important;
  background-color: #ffffff;
  background: #ffffff;
  background-image: none;
  min-height: 38px;
  height: 38px;
  outline: none;

  width: 100%;

  &:-webkit-autofill,
  &:-webkit-autofill:first-line,
  &focus:-webkit-autofill {
    border-color: #e5dfa1;
    box-shadow: 0 0 0 100px #fffff1 inset;
  }
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
`;
//# sourceMappingURL=BKJTextInput.css.styled.js.map